import { render } from "@/components/pages/individualWorkSupport/requirement088/Requirement088.html?vue&type=template&id=4656a130&external"
import script from "@/components/pages/individualWorkSupport/requirement088/Requirement088.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement088/Requirement088.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__